/*
 * File: UIToolbar.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe on 02/26/2018
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the toolbar used in the navigation bar
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Toolbar, Typography, IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  flex: {
    flex: 1
  },
  rightNav: {
    position: "absolute",
    right: theme.spacing(2.5),
    color: theme.palette.common.white,
    top: theme.spacing(2)
  },
  navIconHide: {
    position: "absolute",
    left: theme.spacing(0.5),
    color: theme.palette.common.white,
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  title: {
    margin: "0 auto",
    textAlign: "center",
    color: theme.palette.common.white,
    letterSpacing: theme.spacing(0.2)
  },
  subTitle: {
    position: "absolute",
    top: theme.spacing(4),
    left: 0,
    right: 0,
    margin: "auto",
    opacity: 0.8,
    fontSize: theme.spacing(1.5)
  }
});

const UIToolbar = ({
  classes,
  handleDrawerToggle,
  title,
  subTitle,
  rightNav,
  editButtonComponent
}) => {
  return (
    <Toolbar>
      <IconButton onClick={handleDrawerToggle} className={classes.navIconHide}>
        <MenuIcon />
      </IconButton>

      <Typography variant="h5" className={classes.title} noWrap>
        {title}

        {subTitle && <span className={classes.subTitle}>{subTitle}</span>}
      </Typography>

      {editButtonComponent && <div>{editButtonComponent}</div>}

      {rightNav && <div className={classes.rightNav}>{rightNav}</div>}
    </Toolbar>
  );
};

UIToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  rightNav: PropTypes.object,
  editButtonComponent: PropTypes.object
};

export default withStyles(styles)(UIToolbar);
